import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, Switch, Divider, Tooltip, Space } from "antd";
import { SEOServices } from "../../Services/SEOServices";
import { notify } from "../../customs/NotifyProvider";
import { InfoCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const ContactPC = () => {
    const [form] = Form.useForm();
    const [seoData, setSeoData] = useState(null);

    const onFinish = async (values) => {
        console.log("All Form Data:", values);

        try {
            const formattedVal = { content: { ...values }, page_id: 3 };

            let response;

            console.log(seoData);


            if (seoData?.id) {
                response = await SEOServices.updatePCDetails(
                    seoData.id,
                    formattedVal
                );
            }
            else {
                response = await SEOServices.addPCDetails(formattedVal);
            }

            if (response?.status) {
                notify.success(response.message);
                getPageSeo();
            } else {
                notify.error(response.message);
            }
        } catch (error) {
            console.error(error);
            notify.error("Something went wrong");
        }
    };

    const getPageSeo = async () => {
        try {
            const response = await SEOServices.getPCDetialById(3);

            if (response?.data?.length > 0) {
                const recordString = response?.data?.[0]?.content;

                const record = recordString ? JSON.parse(recordString) : null;

                console.log(record);

                console.log(response?.data[0]?.content);

                setSeoData(response?.data[0]);        // store existing record
                form.setFieldsValue(record); // populate form
            } else {
                setSeoData(null);
                form.resetFields();
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getPageSeo();
    }, []);



    return (
        <div style={{ padding: 20 }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"

            >
                {/* Top Banner Card */}
                <Card title="Top Banner" style={{ marginBottom: 20 }}>
                    <Form.Item
                        label="Banner Image URL"
                        name="bannerImage"
                        rules={[{ required: true, message: "Please input banner image URL!" }]}
                    >
                        <Input placeholder="Enter top banner image URL" />
                    </Form.Item>
                    <Form.Item
                        label="Alt text"
                        name="bannerImage_alt_text"

                    >
                        <Input placeholder="Alt text for image " />
                    </Form.Item>

                    <Form.Item
                        label="Bread curmbs"
                        name="bread_curmbs"
                    >
                        <Input placeholder="Enter Bread Curmbs" />
                    </Form.Item>

                    <Form.Item
                        label="Small Title"
                        name="smallTitle"
                        rules={[{ required: true, message: "Please input small title!" }]}
                    >
                        <Input maxLength={20} showCount placeholder="Enter small title (max 10 chars)" />
                    </Form.Item>

                    <Form.Item
                        label="Main Title"
                        name="mainTitle"
                        rules={[{ required: true, message: "Please input main title!" }]}
                    >
                        <Input placeholder="Enter main title" />
                    </Form.Item>
                </Card>

                {/* Section Content Card */}
                <Card title="Section Content" style={{ marginBottom: 20 }}

                >
                    <Form.Item
                        label="Visit Us | Address"
                        name="address"
                    >
                        <Input placeholder="Enter address" />
                    </Form.Item>

                    <Form.Item
                        label="Call Us | Contact Number"
                        name="contact_num"

                    >
                        <Input placeholder="Alt text for image" />
                    </Form.Item>

                    <Form.Item
                        label="Section Title"
                        name="sectionTitle"
                    >
                        <Input placeholder="Enter section title" />
                    </Form.Item>

                    <Form.Item
                        label="Mail Us | Mail"
                        name="mail"
                    >
                        <Input placeholder="Enter mail" />
                    </Form.Item>

                    <Divider />

                    <Form.Item
                        label={
                            <Space>
                                Submission Receiver Number&nbsp;
                                <Tooltip title="WhatsApp number that will receive submitted form details">
                                    <InfoCircleOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            </Space>
                        }
                        name="contact_no"
                        rules={[
                            { pattern: /^[0-9]{10,15}$/, message: 'Enter a valid phone number' },
                        ]}
                    >
                        <Input
                            placeholder="WhatsApp number to receive submissions"
                            maxLength={15}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span>
                                Google Map Embed URL&nbsp;
                                <Tooltip title="Paste the full Google Maps iframe. Only the src URL will be saved.">
                                    <InfoCircleOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            </span>
                        }
                        name="gmap_src"
                        rules={[
                            { required: true, message: 'Google Map embed URL is required' },
                            { type: 'url', message: 'Invalid URL format' },
                        ]}
                    >
                        <Input
                            placeholder="Paste Google Maps iframe here"
                            onPaste={(e) => {
                                const pastedText = e.clipboardData.getData('text');

                                // Extract src=""
                                const match = pastedText.match(/src="([^"]+)"/);

                                if (match?.[1]) {
                                    e.preventDefault();

                                    // Set extracted value as actual Form value
                                    form.setFieldsValue({
                                        gmap_src: match[1],
                                    });
                                }
                            }}
                        />
                    </Form.Item>





                    {/* Active / Inactive Toggle */}

                </Card>

                {/* Single Save Button */}
                <Form.Item style={{ textAlign: "right" }}>
                    <Button type="primary" htmlType="submit">
                        Save All Content
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default ContactPC;
